import {Map, fromJS, List} from "immutable";

import {FETCH_INVOICES_REQUEST, FETCH_INVOICES_SUCCESS, FETCH_INVOICES_ERROR, CLEAN_INVOICES_STATE} from "./invoices-actions"

const invoices = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case FETCH_INVOICES_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case FETCH_INVOICES_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case FETCH_INVOICES_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        // Clean State
        case CLEAN_INVOICES_STATE:
            newState = state.merge({
                payload: undefined,
                isFetching: false,
                error: false
            });
            return newState;

        default:
            return state;
    }
};

export default invoices;